<template>
    <div>
        <template v-if="imgUrl">
            <b-img rounded :src="imgUrl" style="max-height: 400px; max-width: 400px;" @click="openModal"
                class="cursor-pointer" />
        </template>
        <template v-else>
            -
        </template>
        <b-modal v-model="showModal.value" size="xl" id="modal-p3b-validasi" hide-footer scrollable @hidden="onModalClose"
            @ok="onModalConfirm">
            <div class="text-center">
                <b-img rounded :src="imgUrl" />
            </div>
        </b-modal>
    </div>
</template>
  
<script>
import { ref, onMounted, watchEffect, nextTick } from '@vue/composition-api'

export default {
    props: {
        imgUrl: {
            type: String,
            required: true,
        },
    },
    data() {
        const showModal = ref(false)
        const showModalRef = ref(null);
        const openModal = () => {
            showModal.value = true;
        }
        return {
            showModalRef,
            showModal,
            openModal
        }
    },
    methods: {
        onModalClose() {
            this.showModal.value = false
        },
        onModalConfirm() {
            this.showModal.value = false
        },

    },
}
</script>
  